import http from '@/plugins/http';

export default () => new Promise((res, rej) => {
  http.get('/v3/customer/sign_up_tunnel')
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
